// Membership wizard step — pass expiry (SLICE-MEMBERSHIP-PASS).
//
// Reuses the shared ExpirationFields control, WITHOUT loyalty's
// "stay_completed only" gate — a membership pass can expire in any mode. The
// gym use case is the relative term (1 month / 1 year). Expiry is locked after
// activation (the API 409s STRUCTURAL_LOCKED), so this step is only shown for a
// draft — the wizard restricts an active membership to the cosmetic steps.

import type { BuilderController } from '../hooks/useBuilder.js'
import { ExpirationFields } from './ExpirationFields.js'

export function StepMembershipExpiry({
  builder,
  readOnly = false,
}: {
  builder: BuilderController
  readOnly?: boolean
}) {
  return (
    <div className="program-step">
      <h2>When does the membership expire?</h2>
      <p className="program-step-sub">
        Most memberships renew on a term — e.g. 1 month or 1 year after a member
        signs up. Pick "never expires" for a lifetime membership. This is locked
        once you activate.
      </p>
      <ExpirationFields builder={builder} readOnly={readOnly} />
    </div>
  )
}
